import React from 'react';

interface FormattedNumberProps {
  value: number | null | undefined;
  locale?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  currency?: string;
  placeholder?: string;
}

const FormattedNumber: React.FC<FormattedNumberProps> = ({
  value,
  locale = 'en-US',
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  currency,
  placeholder = '$0.00',
}) => {
  if (value === null || value === undefined || isNaN(value)) {
    return <span>{placeholder}</span>;
  }
  const normalizedValue = Math.abs(value) < 1e-10 ? 0 : value;
  const isNegative = normalizedValue < 0;
  const absValue = Math.abs(normalizedValue);

  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits,
    maximumFractionDigits,
  };

  if (currency) {
    options.style = 'currency';
    options.currency = currency;
  }

  const formatted = absValue.toLocaleString(locale, options);

  // If negative, wrap with parentheses
  return <span>{isNegative ? `($${formatted})` : `$${formatted}`}</span>;
};

export default FormattedNumber;
